export const generateWorkshopPagePrefix = (workshop) => {
  return generateWorkshopPagePrefixFromAffiliationName(workshop.affiliation_name)
}

export const generateWorkshopPagePrefixFromAffiliationName = (affiliationName) => {
  return affiliationName ? encodeURI(affiliationName.toLowerCase()) : 'verksted'
}
